import { useTheme } from '@mui/material';
import { ReactNode } from 'react';
import { StepContentContainer, StepContentContent } from './styles';
import { Heading4, TextM } from '../typography';

export interface IStepContentProps {
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
}

const StepContent = ({
  title,
  description,
  children,
  action,
}: IStepContentProps) => {
  const theme = useTheme();
  return (
    <StepContentContainer>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div>
          <Heading4
            fontWeight="Md"
            style={{ color: theme.palette.brand.secondary.base }}
          >
            {title}
          </Heading4>

          {description && (
            <TextM
              weight="Regular"
              style={{ color: theme.palette.brand.secondary.base }}
            >
              {description}
            </TextM>
          )}
        </div>
        {action ?? null}
      </div>
      <StepContentContent>{children}</StepContentContent>
    </StepContentContainer>
  );
};

export default StepContent;
